import { Descriptions as AntdDescriptions, type DescriptionsProps as AntdDescriptionsProps } from 'antd'
import { createStaticStyles } from 'antd-style'
import { useI18n } from 'context/I18nProvider'

const classNames = createStaticStyles(({ css }) => ({
  title: css`
    font-size: 14px;
  `,
  label: css`
    width: 16rem;
  `,
}))

const Descriptions = ({ items = [], styles, ...props }: AntdDescriptionsProps) => {
  const { i18n } = useI18n()

  return (
    <AntdDescriptions
      column={1}
      size="small"
      classNames={classNames}
      {...props}
      items={items.map(({ label, children, key, ...item }) => {
        const itemLabel = label ?? key

        return {
          ...item,
          key,
          label: typeof itemLabel === 'string' ? i18n(itemLabel) : itemLabel,
          children: <div className="flex w-full">{children || '-'}</div>,
        }
      })}
      styles={styles}
    />
  )
}

export default Descriptions
